/* eslint-disable @typescript-eslint/ban-ts-comment */
import type { Equipment, XrefCables } from "@/composables/forms/formTypes";
import type { ScenarioCalculations } from "@/composables/scenarioCalculations/calculationTypes";
import type { ConvertableUnit } from "@/libs/units";
import { calculateCableTemperatureDataSets } from "./calculateCableTemperatureDataSets";
import type {
  CableTemperatureChartContext,
  CableTemperatureChartData
} from "./d";

const buildCableTemperatureChartContext = (
  scenarioCalcuations: ScenarioCalculations,
  targetTempUnit: ConvertableUnit
): CableTemperatureChartContext | undefined => {
  const destructuredScenario = scenarioCalcuations.destructuredScenario;
  if (!destructuredScenario) return undefined;
  // @ts-ignore
  const equipment = destructuredScenario.equipment?.value as Equipment;
  const context: CableTemperatureChartContext = {
    destructuredScenario,
    calcs: scenarioCalcuations,
    equipment,
    cables: destructuredScenario.cables.value as Record<
      string,
      XrefCables[number]
    >,
    minTemp: 0,
    targetTempUnit,
    motorCalculations: scenarioCalcuations.motorCalculations,
    cableCalculations: {
      individual: scenarioCalcuations.cableCalculations.individual.value,
      aggregate: scenarioCalcuations.cableCalculations.aggregate
    }
  };

  return context;
};

export const useCableTemperatureChartingData = (
  scenarioCalculations: ScenarioCalculations,
  targetTempUnit: ConvertableUnit
): CableTemperatureChartData | undefined => {
  const context = buildCableTemperatureChartContext(
    scenarioCalculations,
    targetTempUnit
  );
  if (!context) {
    return undefined;
  } else {
    const dataSets = calculateCableTemperatureDataSets(context);
    return {
      context,
      dataSets
    };
  }
};
